import PreventDeletionModal from "./PreventDeletionModal";

export default PreventDeletionModal;
